module.exports = __webpack_public_path__ + "static/media/Entry-Homepage-Step 3-FR.a68537c1.png";